export function prevnextF(event, direction) {
  let stepNumber = event.target.parentElement.parentElement.parentElement.getAttribute('data-demo-step');
  event.target.parentElement.parentElement.parentElement.classList.remove("active-demo");
  let dataStepValue = 0;
  if (direction === 'next') {
    dataStepValue = +stepNumber + 1;
  } else {
    dataStepValue = +stepNumber - 1;
  }
  let currentStepNumber = 'data-demo-step=' + '"' + dataStepValue + '"';
  let curentStep = document.querySelectorAll('[' + currentStepNumber + ']');
  if (curentStep.length > 0) {
    curentStep[0].className += ' active-demo';
  }
}

export function closeExplanationF() {
  let currentExplanation = document.getElementsByClassName('active-demo');
  currentExplanation[0].classList.remove('active-demo');
}

export function showCurrentExplanationF(event){
  let currentQuestion = event.target;
  currentQuestion.parentElement.classList += ' active-demo';
}